// these are the ones to send into the backend; currently not being used in this implementation; honestly don't know if we're going to need this or not later, let's see how things go
// export interface accountTypeMapping {
//   investment: ["CUSTODIAL_OTHER", "INDIVIDUAL",
//   "TRUST_IRREVOCABLE", "TRUST_REVOCABLE"],
//   bank: ["BANK"],
//   retirementAndAnnuities: ["ANNUITY_GENERAL",
//     "ANNUITY_VARIABLE",
//     "EMPLOYER_401K",
//     "EMPLOYER_401K_ROTH",
//     "EMPLOYER_403B",
//     "EMPLOYER_403B_ROTH",
//     "EMPLOYER_BROKERAGE",
//     "EMPLOYER_DEFERRED_COMPENSATION",
//     "EMPLOYER_EMPLOYEE_OWNERSHIP",
//     "EMPLOYER_MPP",
//     "EMPLOYER_OTHER",
//     "EMPLOYER_PENSION",
//     "IRA_SEP",
//     "IRA_SIMPLE",
//     "SBS_I401K",
//     "SBS_I401K_ROTH",
//     "SBS_KEOGH",
//     "IRA_INHERITED_ROTH",
//     "IRA_INHERITED_TRADITIONAL",
//     "IRA_ROLLOVER",
//     "IRA_ROTH",
//     "IRA_TRADITIONAL"
//   ];
// }


// This is the mapping for matching Personal Wealth Inventory's subAccountType dropdowns to what AGO & MEZ accept
export const mappedAccountTypesMap = {
  "investment": {
    "taxable-account": "INDIVIDUAL",
    "private-investment": "UNKNOWN",
    // Need Jacqui's response on this, currently choosing this right now based on what's on the spreadsheet
    "charitable-account": "UNKNOWN",
  },
  // "bank" --> don't need bank because I don't think that it has a dropdown
  "retirement-accounts-annuities": {
    "401k": "EMPLOYER_401K",
    "403b": "EMPLOYER_403B",
    "fixed-annuity": "ANNUITY_GENERAL",
    "inherited-ira": "IRA_INHERITED_TRADITIONAL",
    "inherited-roth-ira": "IRA_INHERITED_ROTH",
    "other-company-plan": "EMPLOYER_OTHER",
    "rollover-ira": "IRA_ROLLOVER",
    "roth-ira": "IRA_ROTH",
    "roth-401k": "EMPLOYER_401K_ROTH",
    "sep-ira": "IRA_SEP",
    "simple-ira": "IRA_SIMPLE",
    "traditional-ira": "IRA_TRADITIONAL",
    "variable-annuity": "ANNUITY_VARIABLE"
  },
  "real-estate": {
    "investment": "INVESTMENT",
    "personal": "PERSONAL",
  },
  "liabilities": {
    "mortgage": "MORTGAGE",
    "liabilities": "LIABILITIES",
  }
}

// This is what we're checking accountTypes against to get into the EDIT guided-flow
export const editAccountTypesMap = {
  /* HEYHEY, example for the setup of this map
   * 1) Mapped account type we get back from saved accounts
   * 2) Subaccount type that we need for the "Account type" dropdown on the UI
   * 3) Main account type
   * "SAVED_MAPPED_ACCOUNT_TYPE": ["sub-account-type", "main-account-type"]
   */

  // TODO: 10/28/2025 - Currently adding back UNKNOWN and CUSTODIAL_OTHER accounts to be editable on PWI by setting them to have primary account type of investment and sub account type of taxable-account
  "UNKNOWN": ["taxable-account", "investment"],
  "CUSTODIAL_OTHER": ["taxable-account","investment"],

  "INDIVIDUAL": ["taxable-account", "investment"],
  "BANK_ACCOUNT": ["bank-accounts", "bank-accounts"],
  "EMPLOYER_401K": ["401k", "retirement-accounts-annuities"],
  "EMPLOYER_403B": ["403b", "retirement-accounts-annuities"],
  "ANNUITY_GENERAL": ["fixed-annuity", "retirement-accounts-annuities"],
  "IRA_INHERITED_TRADITIONAL": ["inherited-ira", "retirement-accounts-annuities"],
  "IRA_INHERITED_ROTH": ["inherited-roth-ira", "retirement-accounts-annuities"],
  "EMPLOYER_OTHER": ["other-company-plan", "retirement-accounts-annuities"],
  "IRA_ROLLOVER": ["rollover-ira", "retirement-accounts-annuities"],
  "IRA_ROTH": ["roth-ira", "retirement-accounts-annuities"],
  "EMPLOYER_401K_ROTH": ["roth-401k", "retirement-accounts-annuities"],
  "IRA_SEP": ["sep-ira", "retirement-accounts-annuities"],
  "IRA_SIMPLE": ["simple-ira", "retirement-accounts-annuities"],
  "IRA_TRADITIONAL": ["traditional-ira", "retirement-accounts-annuities"],
  "ANNUITY_VARIABLE": ["variable-annuity", "retirement-accounts-annuities"]
}

// TODO: From Rob the TL; separate out the routes & accounts/assets from the stateObj

export const editAssetTypesMap = {
  "INVESTMENT": ["investment", "real-estate"],
  "PERSONAL": ["personal", "real-estate"]
}

// TODO: Determine the correct sub-type for trust accounts (first value in array)
// Currently using "trust" as a placeholder for both sub-type and main type
// These are Vanguard trust account types that use the trust-specific edit flow (editTrustAccount)
export const editTrustAccountTypesMap = {
  "LIVING_TRUST": ["trust", "trust"],
  "UNDER_WILL_TRUST": ["trust", "trust"],
  "GRANTOR_TRUST": ["trust", "trust"],
  "BANKRUPTCY_TRUST": ["trust", "trust"]
}
